/* global $ */
/* global URLS */
/* global gettext */

(function (scope) {
  "use strict";

  /**
   * @constructor
   */
  var PrintScaleDecorator = (scope.PrintScaleDecorator = function () {
    this.updatedDesign = null;

    this.$el.on(
      "change",
      ".PrintScale input[type=range]",
      this.rangeChanged.bind(this)
    );
    this.$el.on(
      "change",
      ".PrintScale input[name=scale]",
      this.scaleChanged.bind(this)
    );
    this.$el.on(
      "input",
      ".PrintScale input[type=range]",
      this.scaleChanging.bind(this)
    );
    this.$el.on(
      "change",
      ".PrintScale .setting-scale-input",
      this.dimensionChanged.bind(this)
    );
    this.$el.on(
      "change",
      ".PrintScale input[type=radio]",
      this.unitChanged.bind(this)
    );

    //variable use to calculate the value of the slider (logarithmic)
    this.logsl = new LogSlider({
      minpos: 1,
      maxpos: 100,
      minval: 1,
      maxval: 2000,
    });
  });

  PrintScaleDecorator.prototype.getDesign_uuid = function (event) {
    return (
      $(event.currentTarget).parents("[data-uuid]").data("uuid") ||
      this.design.model_uuid
    );
  };

  /**
   * Callback when the input range is moved: update displayed values but the new scale is only saved when
   * the user stops moving the range.
   * @private
   * @param {object} event
   */
  PrintScaleDecorator.prototype.scaleChanging = function (event) {
    var scale = this.logsl.value(+$(event.currentTarget).val()) / 100;
    scale = scale.toFixed(11);
    this.updateScale(scale, this.getDesign_uuid(event));
  };

  /**
   * Callback on range input changed
   * @private
   * @param {object} event
   */
  PrintScaleDecorator.prototype.rangeChanged = function (event) {
    var scale = this.logsl.value(+$(event.currentTarget).val()) / 100;
    scale = scale.toFixed(11);
    this.updateScale(scale, this.getDesign_uuid(event));
    this.notifyUpdateScale(scale, this.getDesign_uuid(event));
  };

  /**
   * Check that the input number is a float and reset scale if not
   * @private
   * @param {object} event
   */
  PrintScaleDecorator.prototype.isANumber = function (event) {
    var result = {};
    var cleanVal = $(event.currentTarget)
      .val()
      .replace(/\,/g, ".")
      .replace(/([^0-9\.])/g, "");
    cleanVal = parseFloat(cleanVal);

    result.cleanVal = cleanVal;
    // #5835
    // If the user try to set a value that is not correct ( No value, 0, random letters ect...)
    // We call the updateScale on settings to force the field to be restored
    // The value that the user set is discard and we keep the last value used
    // then we notify the user with a warning message
    // + we return the function
    if (isNaN(cleanVal) || cleanVal == 0) {
      this.controller.views.settings.updateScale();
      this.controller.notify("warn", sculpteo.WARNING.SCALE_VALUE_NUMBER, true);
      result.isANumber = false;
      return result;
    } else {
      result.isANumber = true;
      return result;
    }
  };

  /**
   * Callback on scale input range changed
   * @private
   * @param {object} event
   */
  PrintScaleDecorator.prototype.scaleChanged = function (event) {
    if (!this.isANumber(event).isANumber) return;
    var scale = $(event.currentTarget).val();
    scale = $(event.currentTarget).val() / 100;

    scale = scale.toFixed(11);
    this.updateScale(scale, this.getDesign_uuid(event));
    this.notifyUpdateScale(scale, this.getDesign_uuid(event));
  };

  /**
   * Callback on dimension field change
   * @private
   * @param {object} event
   */
  PrintScaleDecorator.prototype.dimensionChanged = function (event) {
    // Cleaning value
    var design;
    // if this parts exist it means that we are on a multi print page.
    // In that case we need to get the design of the current scale input
    if (this.parts) {
      design = this.parts[this.getDesign_uuid(event)];
    }
    // otherwise we are on a single print page
    // just use this.design
    else {
      design = this.design;
    }

    var result = this.isANumber(event);
    if (!result.isANumber) return;
    var cleanVal = result.cleanVal;
    cleanVal = Utils.decimalPrecision(design, cleanVal);

    // Computing scale
    var scale = cleanVal / design.size[$(event.currentTarget).attr("name")];
    scale = scale.toFixed(11);

    this.updateScale(scale, this.getDesign_uuid(event));
    this.notifyUpdateScale(scale, this.getDesign_uuid(event));
  };

  /**
   * Notify controller to update scale
   * Separated from previous code to be overrided in PrintMultipleHeaderView.js
   *
   * @private
   * @param {float} scale
   * @param {string} model_uuid
   */
  PrintScaleDecorator.prototype.notifyUpdateScale = function (
    scale,
    model_uuid
  ) {
    this.controller.updateScale(scale, model_uuid);
  };

  /**
   * Callback on unit field change
   * @private
   * @param {object} event
   */
  PrintScaleDecorator.prototype.unitChanged = function (event) {
    var unit = $(event.currentTarget).val();
    this.controller.updateUnit(unit, this.getDesign_uuid(event));
  };

  //use to calculate the logarithmic of the slider
  function LogSlider(options) {
    options = options || {};
    this.minpos = options.minpos || 1;
    this.maxpos = options.maxpos || 100;
    this.minlval = Math.log(options.minval || 1);
    this.maxlval = Math.log(options.maxval || 2000);

    this.scale = (this.maxlval - this.minlval) / (this.maxpos - this.minpos);
  }

  LogSlider.prototype = {
    // Calculate value from a slider position
    value: function (position) {
      return Math.exp((position - this.minpos) * this.scale + this.minlval);
    },
    // Calculate slider position from a value
    position: function (value) {
      return this.minpos + (Math.log(value) - this.minlval) / this.scale;
    },
  };
})((window.sculpteo = window.sculpteo || {}));
